import React from 'react';
import translate from '../translate';
import UsagePeriodItem from './usage-overview-item';
import { UsageByYearMonth } from '../../store/usageDataSlice';
import UsageOverviewChart from './usage-overview-chart';

interface Props {
    strings: any;
    loading: boolean;
    data: UsageByYearMonth;
}

function UsageOverviewCard(props: Props) {
    const getItems = () => {
        const years = Object.keys(props.data);
        if (props.loading) {
            return (
                <div className="year-wrapper">
                    <div className="info-message">{props.strings.loading}</div>
                </div>
            );
        }
        if (!years || years.length === 0) {
            return (
                <div className="year-wrapper">
                    <div className="info-message">{props.strings.noData}</div>
                </div>
            );
        }
        return years
            .sort()
            .reverse()
            .map((year) => (
                <UsagePeriodItem
                    key={year}
                    year={year}
                    months={props.data[year]}
                />
            ));
    };

    return (
        <div className="card level-1">
            <div className="card-content">
                <div className="card-desc">
                    <h3 className="headline1"> {props.strings.title} </h3>
                </div>
                <div>
                    <UsageOverviewChart
                        height={250}
                        usageHistory={props.data}
                    />
                </div>
                {getItems()}
            </div>
        </div>
    );
}

export default translate('UsagePeriodsCard')(UsageOverviewCard);
